/**
 * Article  Functional Component
 * @Package - seo/part
 * @Author - Cybage@UPWA-Team
 * @description: Article related to part SEO
 */
/**
 *  Part SEO's Article Component
 */
import React, { useMemo } from 'react'
import SeoArticle from '../../SeoArticle'

export default function Article({ dynamicApiData }) {
  const articles = useMemo(
    () => (dynamicApiData && dynamicApiData.articles) || {},
    [dynamicApiData],
  )
  const dataArticle = useMemo(() => (articles && articles.data) || [], [
    articles,
  ])
  const attributes = useMemo(
    () => (dynamicApiData && dynamicApiData.attributes) || {},
    [dynamicApiData],
  )

  const products = useMemo(
    () => (dynamicApiData
         && dynamicApiData.products
         && dynamicApiData.products.items)
       || [],
    [dynamicApiData],
  )

  const productsImages = products
    .reduce((row, value) => {
      const image = value.productImageUrl || ''
      const imageArr = image.split('/')
      const index = imageArr.length - 1
      // eslint-disable-next-line no-negated-condition
      const fileName = typeof imageArr[index] !== 'undefined' ? imageArr[index] : ''

      if (row.length <=3) {
        row.push(fileName)
      }

      return row
    }, [])

  const hasDataArticles = useMemo(
    () => Boolean(
      dataArticle
           && Array.isArray(dataArticle)
           && Boolean(dataArticle && dataArticle.length)
           && dataArticle.find(article => article.text.replace(/\s+/g, '').length),
    ),
    [dataArticle],
  )
  const headings = useMemo(() => dynamicApiData && dynamicApiData.headings, [
    dynamicApiData,
  ])
  const article = useMemo(() => (hasDataArticles ? dataArticle : []), [
    dataArticle,
    hasDataArticles,
  ])
  const articlesHeadings = headings && headings.articles ? headings.articles : ''
  const dataImage = articles && articles.image ? articles.image : ''
  const dataAltText = articles && articles.image ? articles.altText : ''
  const pageType = dynamicApiData && dynamicApiData.pageType ? dynamicApiData.pageType : ''

  return (
    <SeoArticle
      id="PartArticle"
      data={article}
      title={articlesHeadings}
      image={dataImage}
      altText={dataAltText}
      pageType={pageType}
      attributes={attributes}
      images={productsImages}
    />
  )
}
